"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadApi = exports.LeadApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
/**
 * LeadApi - axios parameter creator
 * @export
 */
const LeadApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {IClientEntity} iClientEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManualLead: async (iClientEntity, options = {}) => {
            // verify required parameter 'iClientEntity' is not null or undefined
            (0, common_1.assertParamExists)('createManualLead', 'iClientEntity', iClientEntity);
            const localVarPath = `/api/lead/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iClientEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} leadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: async (leadId, options = {}) => {
            // verify required parameter 'leadId' is not null or undefined
            (0, common_1.assertParamExists)('getLead', 'leadId', leadId);
            const localVarPath = `/api/lead/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (leadId !== undefined) {
                localVarQueryParameter['lead_id'] = leadId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewLeadCount: async (options = {}) => {
            const localVarPath = `/api/lead/count-new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IUpdateLeadBody} iUpdateLeadBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: async (iUpdateLeadBody, options = {}) => {
            // verify required parameter 'iUpdateLeadBody' is not null or undefined
            (0, common_1.assertParamExists)('updateLead', 'iUpdateLeadBody', iUpdateLeadBody);
            const localVarPath = `/api/lead/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateLeadBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LeadApiAxiosParamCreator = LeadApiAxiosParamCreator;
/**
 * LeadApi -
 */
var LeadApi;
(function (LeadApi) {
    /**
     *
     * @param {IClientEntity} iClientEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadApi
     * url /api/lead/add
     */
    async function createManualLead(iClientEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createManualLead(iClientEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseInlineResponse2004)(res.data);
            return res;
        });
    }
    LeadApi.createManualLead = createManualLead;
    /**
     *
     * @param {number} leadId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadApi
     * url /api/lead/get
     */
    async function getLead(leadId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getLead(leadId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIClientEntity)(res.data);
            return res;
        });
    }
    LeadApi.getLead = getLead;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadApi
     * url /api/lead/count-new
     */
    async function getNewLeadCount(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getNewLeadCount(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    LeadApi.getNewLeadCount = getNewLeadCount;
    /**
     *
     * @param {IUpdateLeadBody} iUpdateLeadBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadApi
     * url /api/lead/update
     */
    async function updateLead(iUpdateLeadBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateLead(iUpdateLeadBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    LeadApi.updateLead = updateLead;
})(LeadApi || (exports.LeadApi = LeadApi = {}));
